import React from 'react';

import FormikInput from "components/input/new/FormikInput";

function CustomerNumber(props) {
    return (
        <FormikInput
            name={'additionalData.customerNumber'}
            label={'shippingMethods.form.field.additionalData.customerNumber.label'}
            placeholder={'shippingMethods.form.field.additionalData.customerNumber.placeholder'}
            required={true}
        />
    );
}

export default CustomerNumber;
